import { useMutation } from "@tanstack/react-query";
import { useNotificationStore } from "@src/shared/components/Notification";
import { changePassword } from "@src/entities/user/api/request/changePassword";

export const useChangePassword = () => {
  const { showAlert } = useNotificationStore();

  const query = useMutation({
    mutationFn: changePassword,
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
